.container {
    margin-left: auto;
    margin-right: auto;
    padding-left: var(--tempest-space-4);
    padding-right: var(--tempest-space-4);
    width: 100%;
}

/* Responsive horizontal padding — wider on larger viewports. */
@media (min-width: 768px) {
    .container {
        padding-left: var(--tempest-space-6);
        padding-right: var(--tempest-space-6);
    }
}

@media (min-width: 1024px) {
    .container {
        padding-left: var(--tempest-space-8);
        padding-right: var(--tempest-space-8);
    }
}

.container.sm {
    max-width: 640px;
}
.container.md {
    max-width: 768px;
}
.container.lg {
    max-width: 1024px;
}
.container.xl {
    max-width: 1280px;
}
.container.full {
    max-width: 100%;
}

.stack {
    display: flex;
}

.stack.vertical {
    flex-direction: column;
}
.stack.horizontal {
    flex-direction: row;
}
.stack.center {
    align-items: center;
}
.stack.start {
    align-items: flex-start;
}
.stack.end {
    align-items: flex-end;
}
.stack.stretch {
    align-items: stretch;
}
.stack.justifyStart {
    justify-content: flex-start;
}
.stack.justifyCenter {
    justify-content: center;
}
.stack.justifyEnd {
    justify-content: flex-end;
}
.stack.justifyBetween {
    justify-content: space-between;
}
.stack.wrap {
    flex-wrap: wrap;
}

.grid {
    display: grid;
    width: 100%;
}
